import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/store';
import Card from '../ui/Card';
import WeatherCard from './cards/WeatherCard';
import { Calendar } from 'react-feather';
import LoadingSpinner from '../ui/LoadingSpinner';

const WeatherForecast: React.FC = () => {
  const { t } = useTranslation();
  const { forecast, loading } = useSelector((state: RootState) => state.weather);

  if (loading) {
    return (
      <Card>
        <div className="flex justify-center items-center py-8">
          <LoadingSpinner size="md" />
        </div>
      </Card>
    );
  }

  if (!forecast?.daily?.length) {
    return (
      <Card>
        <div className="flex items-center mb-4">
          <Calendar className="mr-2 text-gray-500" />
          <h3 className="text-lg font-semibold">{t('weather.forecast')}</h3>
        </div>
        <div className="text-center py-6 text-gray-500">
          {t('weather.noData')}
        </div>
      </Card>
    );
  }

  return (
    <Card className="bg-gradient-to-br from-white to-gray-50 shadow-md hover:shadow-lg transition-all duration-300">
      <div className="flex items-center mb-6">
        <Calendar className="mr-2 text-blue-500" />
        <h3 className="text-lg font-semibold">{t('weather.forecast')}</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
        {forecast.daily.map((day) => (
          <WeatherCard key={day.date} data={day} />
        ))}
      </div>
    </Card>
  );
};

export default WeatherForecast;